import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Modal } from "react-bootstrap";
import { filterBy } from "@progress/kendo-data-query";
import { ComboBox } from "@progress/kendo-react-dropdowns";
import { useSelector, useDispatch } from "react-redux";
import MainLayout from "../layout";
import TextField from "../../Shared/TextField";
import DropDownField from "../../Shared/DropdownField";
import KendoClientGrid from "./KendoClientGrid";
import { CLIENT_SEARCH_FILTERS } from "../../constants/clientSearchFilters";

import {
  setAllFilters,
  setClientSalesPerson,
} from "../../store/reducers/clientFilterSlice";
import { loadChannelPartners } from "../../handlers/client";

const Clients = () => {
  const dropDownData = useSelector((state) => state.DropdownList);

  const dispatch = useDispatch();
  const clientFilter = useSelector((state) => state.clientFilter);

  const [channelPartner, setChannelPartner] = useState([]);

  const [CustomerData, setCustomerData] = useState(
    dropDownData.CustomersList.slice()
  );

  const [showFilterModal, setShowFilterModal] = useState(false);

  // const toggleSwitch = () => setIsOn(!isOn);

  // States for filters
  const [practiceName, setPracticeName] = useState(clientFilter.practiceName);
  const [practiceEmail, setPracticeEmail] = useState(
    clientFilter.practiceEmail
  );
  const [speciality, setSpeciality] = useState(clientFilter.speciality);
  const [accountType, setAccountType] = useState(clientFilter.accountType);
  const [salesPerson, setSalesPerson] = useState(clientFilter.salesPerson);
  // const [customerId, setCustomerId] = useState(
  //   clientFilter.customerId != null && clientFilter.customerId !== ""
  //     ? {
  //         text: clientFilter.customerId,
  //         value: clientFilter.customerId,
  //       }
  //     : ""
  // ); //  clientFilter.customerId

  const [customerId, setCustomerId] = useState(clientFilter.customerId); // clientFilter.customerId

  const [channel, setChannel] = useState(clientFilter.channel);
  const [alert, setAlert] = useState(clientFilter.alert);
  const [healthScore, setHealthScore] = useState(clientFilter.healthScore);

  useEffect(() => {
    if (sessionStorage.type === "SP") {
      const name = `${sessionStorage.firstName} ${sessionStorage.lastName}`;
      dispatch(setClientSalesPerson(name));
    }
    loadChannelPartners().then((res) => {
      if (res) {
        setChannelPartner(res.channelPartner);
      }
    });
  }, [dispatch]);

  const AlterComboBoxData = (event) => {
    const selectedItem = event.value;
    if (selectedItem == null) {
      setCustomerId(null);
    } else {
      const data = {
        text: selectedItem.text.toString(),
        value: selectedItem.value.toString(),
      };
      setCustomerId(data);
    }
  };

  const applyFilters = () => {
    setShowFilterModal(false);
    dispatch(
      setAllFilters({
        practiceName,
        practiceEmail,
        speciality,
        accountType,
        salesPerson,
        customerId,
        channel,
        alert,
        healthScore,
        currentPage: 1,
      })
    );
  };

  const removeFilters = () => {
    // dispatch(clearFilters());
    setPracticeName("");
    setPracticeEmail("");
    setSpeciality("");
    setAccountType("");
    setSalesPerson("");
    setCustomerId("");
    setChannel("");
    setAlert("");
    setHealthScore("");
  };

  const FilterCustomer = (filter) => {
    const data = dropDownData.CustomersList.slice();
    return filterBy(data, filter);
  };

  const AlterCustomer = (event) => {
    let updatedCustomers = [];
    const newCustomer =
      event.filter.value.length > 2
        ? FilterCustomer(event.filter)
        : dropDownData.CustomersList.slice();
    updatedCustomers = [...new Set(newCustomer)];
    setCustomerData(updatedCustomers);
  };

  return (
    <MainLayout>
      <div role="tabpanel" className="tab-pane page-content-wrapper">
        <div className="table-panel" id="client_table-panel">
          <div className="row table-panel-header">
            <div className="col-md-8 col-sm-12">
              <h6>Clients</h6>
            </div>
            <div className="col-md-4 col-sm-12 flex-center-end">
              <div className="popuop_open">
                <span
                  className="popuop_button"
                  role="button"
                  onClick={() => setShowFilterModal(true)}
                  style={{
                    cursor: "pointer",
                    textDecoration: "none",
                    color: "#007bff",
                    marginLeft: "10px",
                    marginTop: "5px",
                    padding: "5px",
                    borderRadius: "5px",
                    backgroundColor: "#f8f9fa",
                    border: "1px solid #007bff",
                  }}
                >
                  <FontAwesomeIcon icon="filter" size="lg" />
                </span>
              </div>

              <Modal
                show={showFilterModal}
                onHide={() => setShowFilterModal(false)}
                backdrop="static"
                style={{ top: "8%" }}
              >
                <Modal.Header closeButton>
                  <div className="row w-100 align-items-center">
                    <div className="col-md-10 col-sm-10">
                      <Modal.Title className="flex h4 justify-content-center ml-7 modal-title pl-8 text-center">
                        Client Filter
                      </Modal.Title>
                    </div>
                    <div className="col-md-2 col-sm-2">
                      <input
                        type="button"
                        className="white-btn"
                        value="Reset All"
                        onClick={removeFilters}
                      />
                    </div>
                  </div>
                </Modal.Header>
                <Modal.Body>
                  <div className="content">
                    <div className="popup__body">
                      <div className="row">
                        <div className="col-md-6 col-sm-6">
                          <TextField
                            id="practiceName"
                            length={255}
                            label="Practice Name"
                            ReceivedTextData={(textField) => {
                              setPracticeName(textField.fieldValue);
                            }}
                            value={practiceName}
                            required={false}
                          />
                        </div>
                        <div className="col-md-6 col-sm-6">
                          <TextField
                            id="practiceEmail"
                            length={255}
                            label="Practice Email"
                            ReceivedTextData={(textField) => {
                              setPracticeEmail(textField.fieldValue);
                            }}
                            value={practiceEmail}
                            required={false}
                          />
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6 col-sm-6">
                          <DropDownField
                            id="speciality"
                            label="Speciality"
                            bold
                            classDiv
                            required={false}
                            options={CLIENT_SEARCH_FILTERS.SPECIALITY_OPTIONS}
                            value={speciality}
                            ReceivedTextData={(textField) => {
                              setSpeciality(textField.fieldValue);
                            }}
                          />
                        </div>
                        <div className="col-md-6 col-sm-6">
                          <DropDownField
                            id="accountType"
                            label="Account Type"
                            bold
                            classDiv
                            required={false}
                            options={CLIENT_SEARCH_FILTERS.ACCOUNT_OPTIONS}
                            value={accountType}
                            ReceivedTextData={(textField) => {
                              setAccountType(textField.fieldValue);
                            }}
                          />
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6 col-sm-6">
                          <TextField
                            id="salesPerson"
                            bold
                            length={255}
                            label="Sales Person"
                            required={false}
                            disabled={sessionStorage.type === "SP"}
                            value={salesPerson}
                            ReceivedTextData={(textField) => {
                              setSalesPerson(textField.fieldValue);
                            }}
                          />
                        </div>

                        {/* allowCustom={false} */}

                        <div className="col-md-6 col-sm-6">
                          <div className="textBoxValidate field-container">
                            <label className="field-placeholder font-medium">
                              Customer Id
                            </label>
                            <ComboBox
                              className="field-input"
                              data={CustomerData}
                              name="customerId"
                              value={customerId === "" ? null : customerId}
                              textField="text"
                              filterable
                              onFilterChange={AlterCustomer}
                              onChange={AlterComboBoxData}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-6 col-sm-6">
                          <DropDownField
                            id="channel"
                            label="Channel Partner"
                            bold
                            classDiv
                            required={false}
                            options={channelPartner}
                            value={channel}
                            ReceivedTextData={(textField) => {
                              setChannel(textField.fieldValue);
                            }}
                          />
                        </div>
                        <div className="col-md-6 col-sm-6">
                          <DropDownField
                            id="alert"
                            label="Alert"
                            bold
                            classDiv
                            required={false}
                            options={CLIENT_SEARCH_FILTERS.ALERT_OPTIONS}
                            value={alert}
                            ReceivedTextData={(textField) => {
                              setAlert(textField.fieldValue);
                            }}
                          />
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-6 col-sm-6">
                          <DropDownField
                            id="healthScore"
                            bold
                            classDiv
                            label="Health Score:"
                            required={false}
                            options={
                              CLIENT_SEARCH_FILTERS.HEALTH_SCORE_OPTIONS
                            }
                            value={healthScore}
                            ReceivedTextData={(textField) => {
                              setHealthScore(textField.fieldValue);
                            }}
                          />
                        </div>

                        {/* <div className="col-md-4 col-sm-12">
                            <label className="field-placeholder font-medium">
                              Linked Practices
                            </label>

                            <span className="toggle-container">
                              <div
                                className={`toggle-switch ${
                                  isOn ? "on" : "off"
                                }`}
                                onClick={toggleSwitch}
                              >
                                <div className="toggle-knob" />
                              </div>
                              <span className="toggle-info-icon">ℹ️</span>
                            </span>
                          </div> */}
                      </div>
                    </div>
                  </div>
                  <div className="row text-center">
                    <div className="col-md-12 col-sm-12">
                      <label>&nbsp;</label>
                      <input
                        type="button"
                        className="btnLinkBlue"
                        value="Search"
                        onClick={applyFilters}
                      />
                    </div>
                  </div>
                </Modal.Body>
              </Modal>
            </div>
          </div>
          <div
            className="table-panel-body"
            style={{ height: "calc(100vh - 175px)" }}
          >
            <KendoClientGrid />
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default Clients;
